import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";

export const getSDUIFilterName = (
  view_display_page: keyof typeof DisplayPageType | undefined
): FilterName => {
  if (view_display_page === "CATEGORY_PAGE") {
    return FilterName.LOGGED_IN_CATEGORY;
  }
  return FilterName.UNKNOWN;
};
